"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var i18next_1 = __importDefault(require("i18next"));
var core_1 = require("@material-ui/core");
var go_main_logo_svg_1 = __importDefault(require("@assets/go-logo-graphics/go-main-logo.svg"));
var login_page_graphics_svg_1 = __importDefault(require("@assets/login-page-graphics/login-page-graphics.svg"));
var react_redux_1 = require("react-redux");
var actions_1 = __importDefault(require("../app/components/pages/RootPage/actions"));
var asset_variant_1 = __importDefault(require("../../shared/util/asset-variant"));
var format_1 = require("../app/util/format");
var Section_1 = __importDefault(require("../app/components/Section"));
var BaseLayout_1 = __importDefault(require("../app/components/BaseLayout"));
var requests_1 = require("../app/util/requests");
var URL_PREFIX_LENGTH = '#/ogp-login'.length;
var useStyles = (0, core_1.makeStyles)(function (theme) {
    var _a, _b, _c;
    return (0, core_1.createStyles)({
        container: {
            display: 'flex',
            flexGrow: 1,
            '-ms-flex': '1 1 auto',
        },
        loginContainer: (_a = {
                display: 'flex',
                width: '100%'
            },
            _a[theme.breakpoints.up('lg')] = {
                width: '50%',
            },
            _a),
        verticalAlign: (_b = {
                display: 'flex',
                width: '100%'
            },
            _b[theme.breakpoints.up('lg')] = {
                alignItems: 'center',
            },
            _b),
        signInButton: {
            width: '250px',
            minWidth: '120px',
            marginRight: theme.spacing(2),
        },
        loginWrapper: (_c = {
                display: 'block'
            },
            _c[theme.breakpoints.up('lg')] = {
                // Gives the contents slightly more than enough height,
                // so that validation messages do not shift the centering.
                height: '400px',
                maxHeight: '80vh',
            },
            _c),
        headerGroup: {
            marginBottom: theme.spacing(4),
        },
        logo: {
            maxWidth: '130px',
            width: '40%',
        },
        loginHeader: {
            marginTop: theme.spacing(1),
        },
        loginReferral: {
            fontSize: '0.85rem',
            color: '#767676',
            marginBottom: theme.spacing(4),
        },
        graphicColorFill: {
            backgroundColor: theme.palette.primary.dark,
            width: '50vw',
            height: '100%',
            // allocates space for the government masthead when on gov variant
            maxHeight: asset_variant_1.default === 'gov' ? 'calc(100vh - 28px)' : '100vh',
            textAlign: 'center',
            overflow: 'hidden',
        },
        loginGraphic: {
            userDrag: 'none',
            height: '100%',
        },
        '@media screen\\0': {
            // Styles for Internet Explorer compatibility
            logoLink: {
                marginBottom: '0',
            },
        },
    });
});
var SgidLoginPage = function () {
    var dispatch = (0, react_redux_1.useDispatch)();
    var classes = useStyles();
    var queryParams = new URLSearchParams(new URL(window.location.href).hash.substring(URL_PREFIX_LENGTH));
    var setLoginStatusMessage = function (message) {
        return dispatch(actions_1.default.setInfoMessage(message));
    };
    (0, react_1.useEffect)(function () {
        var officerEmail = queryParams.get('officerEmail');
        var statusCode = queryParams.get('statusCode');
        if (officerEmail) {
            setLoginStatusMessage("".concat(officerEmail, " doesn't look like a valid ").concat(i18next_1.default.t('general.emailDomain'), " email."));
        }
        else if (statusCode === '403') {
            setLoginStatusMessage("Unable to fetch a valid work email for authentication.");
        }
        else if (statusCode === '400') {
            setLoginStatusMessage("Authentication failed. Please try again.");
        }
    }, []);
    return (react_1.default.createElement(BaseLayout_1.default, { withHeader: false, withFooter: false, withLowFooter: false },
        react_1.default.createElement("div", { className: classes.container },
            react_1.default.createElement("div", null,
                react_1.default.createElement(core_1.Hidden, { mdDown: true },
                    react_1.default.createElement("div", { className: classes.graphicColorFill },
                        react_1.default.createElement("img", { className: classes.loginGraphic, src: login_page_graphics_svg_1.default, alt: "Login page graphic" })))),
            react_1.default.createElement("div", { className: classes.loginContainer },
                react_1.default.createElement("div", { className: classes.verticalAlign },
                    react_1.default.createElement(Section_1.default, null,
                        react_1.default.createElement("section", { className: classes.loginWrapper },
                            react_1.default.createElement("span", { className: classes.headerGroup },
                                react_1.default.createElement(core_1.Link, { href: "/#/" },
                                    react_1.default.createElement("img", { className: classes.logo, src: go_main_logo_svg_1.default, alt: "GoGovSG logo" })),
                                react_1.default.createElement(core_1.Typography, { className: classes.loginHeader, variant: "body1", dangerouslySetInnerHTML: {
                                        __html: (0, format_1.htmlSanitizer)(i18next_1.default.t('login.whitelistPhrase')),
                                    } }),
                                react_1.default.createElement(core_1.Typography, { className: classes.loginReferral, variant: "body1" },
                                    i18next_1.default.t('login.referrals.1.officerPhrase'),
                                    " can use their",
                                    ' ',
                                    i18next_1.default.t('login.referrals.1.emailDomain'),
                                    " emails at",
                                    ' ',
                                    react_1.default.createElement(core_1.Link, { href: "https://".concat(i18next_1.default.t('login.referrals.1.link')) }, i18next_1.default.t('login.referrals.1.link')),
                                    ", and ",
                                    i18next_1.default.t('login.referrals.2.officerPhrase'),
                                    " can use their ",
                                    i18next_1.default.t('login.referrals.2.emailDomain'),
                                    " emails at",
                                    ' ',
                                    react_1.default.createElement(core_1.Link, { href: "https://".concat(i18next_1.default.t('login.referrals.2.link')) }, i18next_1.default.t('login.referrals.2.link')),
                                    ' ',
                                    "to shorten links."),
                                react_1.default.createElement(core_1.Button, { className: classes.signInButton, type: "submit", variant: "contained", color: "primary", size: "large", onClick: function () {
                                        (0, requests_1.get)('/api/sgidLogin/authurl').then(function (response) { return __awaiter(void 0, void 0, void 0, function () {
                                            var text;
                                            return __generator(this, function (_a) {
                                                switch (_a.label) {
                                                    case 0:
                                                        if (!response.ok) return [3 /*break*/, 2];
                                                        return [4 /*yield*/, response.text()];
                                                    case 1:
                                                        text = _a.sent();
                                                        window.open(text, '_self');
                                                        return [3 /*break*/, 3];
                                                    case 2:
                                                        setLoginStatusMessage('Please try logging in using email.');
                                                        _a.label = 3;
                                                    case 3: return [2 /*return*/];
                                                }
                                            });
                                        }); });
                                    } }, "Log in with Singpass app")))))))));
};
exports.default = SgidLoginPage;
